const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 }

// Default level policy:
//  - 'warn' during automated test runs (NODE_ENV==='test') to reduce log noise
//  - 'warn' in production to avoid verbose logging in user sessions
//  - 'info' in any other environment (dev, local, staging, regression, etc.)
function resolveDefaultLevel() {
    const env = process.env.NODE_ENV
    if (env === 'test' || env === 'production') return 'warn'
    return 'info'
}

let currentLevel = LEVELS[resolveDefaultLevel()]

export function setLogLevel(level) {
    if (LEVELS[level] !== undefined) currentLevel = LEVELS[level]
}

function logAt(level, method, args) {
    if (LEVELS[level] <= currentLevel) {
        // eslint-disable-next-line no-console
        console[method](...args)
    }
}

export const log = {
    error: (...a) => logAt('error', 'error', a),
    warn: (...a) => logAt('warn', 'warn', a),
    info: (...a) => logAt('info', 'log', a),
    debug: (...a) => logAt('debug', 'log', a)
}

export default log
